import React, { useContext } from "react";
import { education, achievements } from "../constants";
import { ThemeContext } from "../themeProvider";
import { motion } from "framer-motion";

const cardVariants = {
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
    },
  },
  hidden: { opacity: 0, scale: 0.8 },
};

const Education = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  const cardClassName = darkMode
    ? "bg-white rounded-lg p-6 shadow-lg"
    : "bg-gray-800 rounded-lg p-6 shadow-lg";
  const titleClassName = darkMode
    ? "text-2xl font-bold text-black"
    : "text-2xl font-bold text-white";
  const bodyClassName = darkMode ? "text-gray-600" : "text-gray-300";

  return (
    <div id="education">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 px-4 pt-24 pb-12">
        <div style={{ width: "100%", alignItems: "center", justifyContent: "center", alignContent: "center", display: "flex" }}>
          <h2
            className={
              darkMode
                ? "text-5xl font-bold px-4 md:px-0 text-center colored-bottom-line"
                : "text-5xl font-bold px-4 md:px-0 text-center text-white colored-bottom-line"
            }
          >
            Education & Awards
          </h2>
        </div>

        <h4 className="mt-16 text-3xl font-semibold multicolortext" style={{ width: "max-content", maxWidth: "100%" }}>
          Where I've Studied
        </h4>

        <div className="mt-8 space-y-6">
          {education.map((item) => (
            <motion.div
              key={item.name}
              initial="hidden"
              whileInView={"visible"}
              variants={cardVariants}
              className={cardClassName}
            >
              <div className="flex flex-col md:flex-row justify-between md:items-center">
                <h3 className={titleClassName}>{item.name}</h3>
                <span className="text-blue-500 font-semibold">{item.period}</span>
              </div>
              <h4 className="text-xl mt-2 font-semibold multicolortext">{item.role}</h4>
              <p className={`mt-4 ${bodyClassName}`}>{item.description}</p>
              {item.details && (
                <div className="mt-4 space-y-2">
                  {item.details.map((detail) => (
                    <div key={detail} className={bodyClassName}>
                      • {detail}
                    </div>
                  ))}
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <h4 className="mt-16 text-3xl font-semibold multicolortext" style={{ width: "max-content", maxWidth: "100%" }}>
          Awards & Achievements
        </h4>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
          {achievements.map((item) => (
            <motion.div
              key={item.name}
              initial="hidden"
              whileInView={"visible"}
              variants={cardVariants}
              className={cardClassName}
            >
              <div className="flex flex-col md:flex-row justify-between md:items-center">
                <h3 className={titleClassName}>{item.name}</h3>
                <span className="text-blue-500 font-semibold">{item.period}</span>
              </div>
              <h4 className="text-xl mt-2 font-semibold multicolortext">{item.role}</h4>
              {item.description && <p className={`mt-4 ${bodyClassName}`}>{item.description}</p>}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Education;
